import {Pipe, PipeTransform} from '@angular/core';
import { OrganizationService } from 'app/main/pages/contacts/organizations/organization.service';
import { BrandingService } from 'app/main/pages/settings/branding/branding.service';

@Pipe({ name: 'getImage' })

/**
 * returns the image
 */
export class getImage implements PipeTransform {
    
    
    constructor(
        private _brandingService: BrandingService,
        private _organizationService: OrganizationService
    ) { }
    
    
    
    transform(image: string, id: number = 0, imageSection: string = ''): string {
        if (image?.includes(';base64')) return image;
        if (image) {
            return imageSection === 'organization' 
                ? this._organizationService.getOrganizationImagesPath(id) 
                : this._brandingService.getBrandingImagesPath(image, id);
        }
        return '';
    }
}
